import React, { Fragment, useEffect, useState } from 'react'
import {t} from 'i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil'
import axios from 'axios';
import { Accordion } from 'react-bootstrap';
import { Container, Card, CardBody, Button, Row, Col, Collapse, CardFooter } from 'reactstrap'

import env from '../../env/src_config';
import { headersState, tokenState } from '../../recoil/recoil';
import { isNull } from '../../izUtils'
import Spinner from '../../components/spinner/Spinner'
import Breadcrumbs from '../../layout/breadcrumb/Breadcrumb'
import { transformer } from '../../helpers/fields';
import { axiosError } from '../../helpers/response';
import PaginationBottom from '../../components/Pagination/PaginationBottom';
import PaginationTop from '../../components/Pagination/PaginationTop';
import ProjectList from '../../components/projects/list/ProjectList';
import Filter from '../../components/filters/Filter';

const AllProjects = () => {
    const navigate = useNavigate();

    const headers = useRecoilValue(headersState);
    const tokenData = useRecoilValue(tokenState);
    const [projects, setProjects] = useState(null)
    const [filters, setFilters] = useState(null)
    const [isFilterOpen, setIsFilterOpen] = useState(true);

    const lsFilterName = 'AKODA.projectsFilter';

    useEffect(() => {
        const lsFilter = JSON.parse(localStorage.getItem(lsFilterName));
        getProjects(isNull(lsFilter) ? {} : lsFilter);

    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getProjects = (passedFilters) => {
        const keys = Object.keys(passedFilters);
        let payload = { filters: {} };
        for (let i = 0; i < keys.length; i++) {
            if (!isNull(passedFilters[keys[i]].value) && passedFilters[keys[i]].value.length !== 0) {
                payload.filters[keys[i]] = passedFilters[keys[i]].value;
            } else {
                payload.filters[keys[i]] = "";
            }
        }

        axios.post(env.api + '/api/project/list', payload, {headers}).then(response => {
            if (!isNull(response.data.data)) {
                setProjects(response.data.data);
                if (!isNull(response.data.filters)) {
                    setFilters(transformer(response.data.filters));
                    localStorage.setItem(lsFilterName, JSON.stringify(transformer(response.data.filters)))
                }
            }
        }).catch(error => {
            axiosError(error, navigate);
        });
    }

    const clearData = () => {
        localStorage.removeItem(lsFilterName)
        getProjects({});
    }

    if (isNull(projects)) {
        return <Spinner />
    } else {
        const filterFields = ['client', 'facility']
        return (
            <Fragment>
                <Breadcrumbs parent="" title={t('breadcrumb.projects')} />
                <Container fluid={true}>
                    <Row>
                        <Col sm="12">
                            <Card className="ribbon-wrapper">
                                <CardBody>
                                    <div className="ribbon ribbon-clip ribbon-primary">{t('projects.list.title')}</div>
                                    <div>
                                        <Accordion className='mb-3'>
                                            <div className="default-according style-1" id="projectsfilter">
                                                <Button color="secondary" className="acc-btn d-flex justify-content-between align-items-center" data-toggle="collapse" onClick={() => setIsFilterOpen(!isFilterOpen)}>
                                                    {t('filters')}
                                                    <div className={'filter-icon' + (isFilterOpen ? ' rotate-icon' : '')}>
                                                        <i className="fa fa-chevron-down"></i>
                                                    </div>
                                                </Button>
                                                <Collapse isOpen={isFilterOpen}>
                                                    <div className='p-3'>
                                                        <Filter filterFields={filterFields} filters={filters} getData={(clonedFilters) => getProjects(clonedFilters)} lsFilterName={lsFilterName} clearData={clearData} />
                                                    </div>
                                                </Collapse>
                                            </div>
                                        </Accordion>
                                        <PaginationTop filters={filters} getData={clonedFilters => getProjects(clonedFilters)} />
                                        <ProjectList data={projects} tokenData={tokenData} />
                                        <PaginationBottom filters={filters} getData={clonedFilters => getProjects(clonedFilters)} />
                                    </div>
                                </CardBody>

                                {tokenData.parsedToken.type === 'admin' &&
                                    <CardFooter>
                                        <div className='text-end'>
                                            <Button color="primary" className="mt-2 me-2" onClick={() => navigate('/projects/create')}>{t('projects.list.addNew')}</Button>
                                        </div>
                                    </CardFooter>
                                }
                            </Card>
                        </Col>
                    </Row>
                    <hr/>
                    <div className='d-flex flex-wrap justify-content-between mb-4'>
                        <div>
                            <Button color="danger" className="mt-2 me-2" onClick={() => navigate('/')}>{t('back')}</Button>
                        </div>
                    </div>
                </Container>
            </Fragment>
        )
    }
}

export default AllProjects